/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("PrintLiveController", function printLiveController(
	$scope,
	$routeParams,
	$q,
	$filter,
	$location,

	dxApi,
	Exam,
	ExamRepository,
	examStatus,
	settingFlags,
	DX_URLS,
	NodeRepository,
	dxSession,

	dxLocalize
) {
	"use strict";

	$scope.studentProgress = [];
	$scope.exam = new Exam();
	$scope.loading = true;

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		$scope.node = node;
	}

	var examId = parseInt($routeParams.id, 10);
	if (!examId) {
		$location.path(DX_URLS[404]());
	}

	$scope.load = function load() {
		var examPromise = ExamRepository.load(examId);
		var progressPromise = dxApi.v1.exams.progress(examId);

		$q.all([examPromise, progressPromise]).then(function allPromisesSuccess(responses) {
			$scope.exam = responses[0];
			$scope.copyStudentProgress(responses[1].data.studentsProgress);
			handleRedactedPiiStudents();
			$scope.loading = false;
		});
	};

	$scope.load();

	function handleRedactedPiiStudents() {
		$scope.studentProgress.forEach(function foreachStudentProgress(student) {
			if (student.redactedPii) {
				student.name = dxLocalize.get("RedactedPii.StudentName");
				student.firstName = dxLocalize.get("RedactedPii.StudentName");
				student.lastName = "";
				student.studentCode = "";
				student.email = "";
			}
		});
	}

	// Copies a student progress array to the scope property by property.
	// This to prevent redraw of the full ng-repeat
	$scope.copyStudentProgress = function copyStudentProgress(newProgress) {
		for (var j = 0; j < newProgress.length; j++) {
			var n = newProgress[j];
			var found = false;
			for (var i = 0; i < $scope.studentProgress.length; i++) {
				var o = $scope.studentProgress[i];
				if (n.id === o.id) {
					// Copy property by property to prevent full rerender of the ng-repeat
					for (var key in n) {
						if (n.hasOwnProperty(key)) {
							o[key] = n[key];
						}
					}
					found = true;
					break;
				}
			}

			if (!found) {
				$scope.studentProgress.push(n);
			}
		}
	};

	// Sorting
	$scope.studentProgressSort = function studentProgressSort(progress) {
		if (new Date(progress.started).getFullYear() !== 1) {
			return 0;
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0) {
			return 1;
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return 3;
		}

		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return 4;
		}

		return 2;
	};

	// Helpers

	//Returns the text for the started column
	$scope.startedText = function startedText(progress) {
		var started = new Date(progress.started);

		if (started.getFullYear() !== 1) {
			return $filter("date")(started, "HH:mm");
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return dxLocalize.get("PenAndPaper");
		}

		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return dxLocalize.get("Absent");
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0) {
			return dxLocalize.get("Offline");
		}

		return "----";
	};

	// Returns the text for the last updated column
	$scope.updatedText = function updatedText(progress) {
		var lastUpdate = new Date(progress.lastUpdate);

		if (lastUpdate.getFullYear() !== 1) {
			return $filter("date")(lastUpdate, "HH:mm");
		}

		return "----";
	};

	// Return the text for the stopped column
	$scope.stoppedText = function stoppedText(progress) {
		var stopped = new Date(progress.stopped);
		var lastOfflineUpload = new Date(progress.lastOfflineUploadTime);

		if (stopped.getFullYear() !== 1 && lastOfflineUpload <= stopped) {
			return $filter("date")(stopped, "HH:mm");
		}

		if (lastOfflineUpload.getFullYear() !== 1) {
			return dxLocalize.get("Offline");
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0 && new Date(progress.started).getFullYear() === 1) {
			return dxLocalize.get("NotDigitally");
		}

		return "----";
	};

	$scope.getExamClass = function getExamClass(progress) {
		if (new Date(progress.started).getFullYear() !== 1) {
			if ($scope.isExamTimedOut(progress)) {
				return "color-offline";
			}

			return "color-active";
		}

		if ((progress.flags & settingFlags.STUDENT_ABSENT) !== 0) {
			return "color-absent";
		}

		if ((progress.flags & settingFlags.TRADITIONAL_EXAM) !== 0) {
			return "color-traditional";
		}

		if ((progress.flags & settingFlags.OFFLINE_START) !== 0 || new Date(progress.lastOfflineUploadTime).getFullYear() !== 1) {
			return "color-offline";
		}

		return "color-idle";
	};

	$scope.isExamTimedOut = function isExamTimedOut(progress) {
		// We have a stopped date, the answers are in and therefore cant be timed out
		if (new Date(progress.stopped).getFullYear() !== 1) {
			return false;
		}

		var timeout = new Date(progress.started);

		// The exam is not started, then it cant be timed out
		if (timeout.getFullYear() === 1) {
			return false;
		}

		// If we have lastUpdate, use that as timeout instead of started
		if (new Date(progress.lastUpdate).getFullYear() !== 1) {
			timeout = new Date(progress.lastUpdate);
		}

		// Timeout
		var fiveMinutes = 1000 * 60 * 5;
		timeout.setTime(timeout.getTime() + fiveMinutes);
		var now = new Date();

		return timeout < now;
	};

	$scope.getStart = function getStart(d) {
		if ($scope.exam.examStatus === examStatus.NOT_STARTED) {
			return dxLocalize.get("NotStarted");
		}
		return $filter("date")(new Date(d), "yyyy-MM-dd HH:mm");
	};

	$scope.getStop = function getStop(d) {
		if ($scope.exam.examStatus === examStatus.NOT_STARTED) {
			return dxLocalize.get("NotStarted");
		} else if ($scope.exam.examStatus === examStatus.ACTIVE) {
			return dxLocalize.get("Ongoing");
		}
		return $filter("date")(new Date(d), "yyyy-MM-dd HH:mm");
	};

	$scope.backHistory = function backHistory() {
		return setTimeout(function setTimeoutCallback() { // eslint-disable-line
			return window.history.back(); // eslint-disable-line
		}, 50);
	};
});
